import { useEffect } from 'react'
import { useRouter } from 'next/router'

// https://nextjs.org/docs/api-reference/next/router#usage-6
const useRouteEffect = (effect: () => void): void => {
  const router = useRouter()

  useEffect(() => {
    if (!router) return // for Storybook

    router.events.on('routeChangeStart', effect)

    return () => {
      router.events.off('routeChangeStart', effect)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // only needs to be run once
}

export default useRouteEffect
